import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Route } from 'react-router-dom';
import { Navbar } from './navbar';
import Footer from './footer';

const useStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '92%',
    // minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    // marginTop: 0,
    maxWidth: 1032,
    padding: 0,
    // [theme.breakpoints.up('md')]: {
    //   padding: 0,
    //   marginBottom: 24,
    //   marginTop: 36,
    // },
  },
  toolbar: theme.mixins.toolbar,
}));

function Layout({ children }) {
  const classes = useStyles();

  return (
    <>
      <Navbar />
      <Container className={classes.main}>{children}</Container>
      <Footer />
    </>
  );
}

export const MainLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};
